module.exports = __webpack_public_path__ + "static/media/mid_mobile_arrow.28a8498e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Users/images/mid_mobile_arrow.svg
// module id = 1492
// module chunks = 0